import React, { useRef, useState } from 'react';
import { Button, Header, Input } from '../../components';
import Loading from '../../components/Loading';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useStateContext } from '../../contexts/ContextProvider';
import axiosClient from '../../axios-client';
import { FaPrint, FaRegFileAlt } from 'react-icons/fa';
import Icon from '../../data/icon.png';
import BulletinElement from '../../components/BulletinElement';
import ReactToPrint from 'react-to-print';
import { GiCancel } from 'react-icons/gi';
import { toast } from 'react-toastify';
import { GrPowerReset } from 'react-icons/gr';
import Entete from '../../components/Entete';

const ShowBulletinFondamental = ({ selectedBulletin, onClose }) => {
    const [loading, setLoading] = useState(false);

    const { token, setToken, user } = useStateContext();

    const bulletinPrintRef = useRef();
    const [bulletinFondamental, setBulletinFondamental] = useState({
        lignes: [],
        lignesFr: [],
        totalAr: 0,
        totalMaxAr: 0,
        totalFr: 0,
        totalMaxFr: 0,
        moyenneAr: 0,
        moyenneFr: 0,
        rang: '',
        matricule: '',
        eleveFr: '',
        eleveAr: '',
        moyenne: '',
        total: '',
        classe: '',
        trimestreAr: '',
        trimestreFr: '',
        mention: '',
        decision: '',
        scolaire: '',
        moyenneMin:'',
        moyenneMax:'',

    });

    const getPrint = () => {
        setLoading(true);
        axiosClient.get('/imprimerBulletinFonadmental/' + selectedBulletin.id)
            .then((data) => {
                setBulletinFondamental({
                    ...bulletinFondamental, lignes: data.data.lignes, lignesFr: data.data.lignesFr, matricule: data.data.matricule,
                    totalAr: data.data.totalAr, totalFr: data.data.totalFr, totalMaxAr: data.data.totalMaxAr, totalMaxFr: data.data.totalMaxFr,
                    rang: data.data.rang, eleveFr: data.data.eleveFr,
                    eleveAr: data.data.eleveAr, moyenne: data.data.moyenne, moyenneAr: data.data.moyenneAr, moyenneFr: data.data.moyenneFr,
                    total: data.data.total, classe: data.data.classe,
                    trimestreAr: data.data.trimestreAr, trimestreFr: data.data.trimestreFr,
                    mention: data.data.mention, decision: data.data.decision, scolaire: data.data.scolaire,
                    moyenneMin:data.data.moyenneMin,moyenneMax:data.data.moyenneMax


                });
                setLoading(false);

            }).catch(err => {
                const response = err.response;
                if (err.response.status === 401) {
                    setToken(null);
                } else {
                    if (response.status === 401) {
                        setToken(null);
                    }
                    else {
                        if (response.status === 403) {
                            navigate('/403');
                        } else {
                            if (response.status === 404) {
                                navigate('/404');
                            }
                            else {
                                navigate('/500');
                            }
                        }
                    }
                }

            })
    }

    const recalculer = () => {
        setLoading(true);
        axiosClient.get('/recalculerBulletinFondamental/' + selectedBulletin.id)
            .then((data) => {
                setLoading(false);
                toast.success('Opération effectuée avec succès!', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });

            }).catch(err => {
                const response = err.response;
                if (err.response.status === 401) {
                    setToken(null);
                } else {
                    if (response.status === 401) {
                        setToken(null);
                    }
                    else {
                        if (response.status === 403) {
                            navigate('/403');
                        } else {
                            if (response.status === 404) {
                                navigate('/404');
                            }
                            else {
                                navigate('/500');
                            }
                        }
                    }
                }

            })
    }

    const navigate = useNavigate();



    useEffect(() => {
        getPrint();
    }, []);
    return (
        <>
            <div className=' fixed inset-0  h-full bg-black bg-opacity-25 backdrop-blur-sm  '>
                <div className='h-screen w-full flex justify-center items-center'>
                    <div className='flex-col w-full max-h-screen max-w-screen-xl orien overflow-auto bg-white lg:p-7 xl:p-7  p-2 md:p-7 rounded-xl'>
                        {loading ? <Loading />
                            :
                            <div className=''>
                                <Header icon={<FaRegFileAlt />} title="Bulletin Fondamental" />
                                <div className="flex-col">
                                    <div className="flex w-full justify-end items-end gap-2">
                                        <ReactToPrint
                                            trigger={() => {
                                                return <Button icon={<FaPrint />} color="ml-1 bg-green-500" textColor="text-white" text="Imprimer" />
                                            }}
                                            content={() => bulletinPrintRef.current}
                                            documentTitle='Bulletin'
                                            pageStyle='bulletin'
                                        />
                                        <Button icon={<GiCancel />} onClick={() => onClose()} color="bg-red-500" textColor="text-white" text="Fermer" />
                                    </div>
                                    <div ref={bulletinPrintRef} className="flex-col relative">
                                        <Entete />
                                        <div className="flex w-full gap-1 justify-center items-center ">
                                            <div className="flex-col font-bold w-full">
                                                <div className="flex w-full justify-center items-center">
                                                    <h2 >   كشف درجات امتـــحــــــــان {bulletinFondamental.trimestreAr}</h2>
                                                </div>
                                                <div className="flex w-full justify-center items-center">
                                                    <h2>Bulletin des notes de la Composition {bulletinFondamental.trimestreFr}</h2>
                                                </div>

                                            </div>
                                        </div>
                                        <div className="flex font-bold gap-3 justify-between my-2">
                                            <BulletinElement left="Matricule: " center={bulletinFondamental.matricule} />
                                            <BulletinElement left="Nom: " center={bulletinFondamental.eleveFr} />
                                            <BulletinElement left="Classe: " center={bulletinFondamental.classe} />
                                            {bulletinFondamental.eleveAr !== null ?
                                                <BulletinElement left="الإس الكامل :" center={bulletinFondamental.eleveAr} />
                                                :
                                                <></>
                                            }
                                        </div>

                                        <div className='flex items-start gap-2 my-2 w-full overflow-x-auto '>
                                            <table className='border border-black'>
                                                <thead>
                                                    <tr >
                                                        <th className='bg-gray-200 border border-black'>
                                                            <div className="flex justify-between w-full">
                                                                <span>
                                                                    Matières Français
                                                                </span>
                                                                <span>
                                                                    مواد الفرنسية
                                                                </span>
                                                            </div>
                                                        </th>
                                                        <th className='bg-gray-200 border w-1/5 border-black'>
                                                            <div className="flex justify-between w-full">
                                                                <span>
                                                                    Note
                                                                </span>
                                                                <span>
                                                                    النتـــيــجـة
                                                                </span>
                                                            </div>
                                                        </th>
                                                    </tr>
                                                </thead>
                                                {loading ? <tbody><tr className='content-center items-center'><td className='content-center items-center' colSpan="9"><Loading /></td></tr></tbody> :
                                                    (
                                                        <tbody className='border border-black'>
                                                            <div className="flex w-full opacity-25 absolute">
                                                                <img className=" mx-auto h-96 w-auto" src={Icon} alt="Your Company" />
                                                            </div>
                                                            {bulletinFondamental.lignesFr && bulletinFondamental.lignesFr.map(o => (
                                                                <>
                                                                    <tr className='font-semibold text-left ' >
                                                                        <td className='border border-black' >{o.libelle}</td>
                                                                        <td className='border  w-1/5 border-black'>{o.note}/{o.noteMax}</td>
                                                                    </tr>
                                                                </>
                                                            ))
                                                            }
                                                            <tr className='font-semibold bg-blue-300 text-left ' >
                                                                <td className='border border-black' >Total</td>
                                                                <td className='border  w-1/5 border-black'>{bulletinFondamental.totalFr}/{bulletinFondamental.totalMaxFr}</td>
                                                            </tr>
                                                        </tbody>
                                                    )
                                                }
                                            </table>
                                            <table className='border border-black'>
                                                <thead>
                                                    <tr className='h-3' >

                                                        <th className='bg-gray-200  border w-1/5 border-black'>
                                                            <div className="flex justify-between w-full">
                                                                <span>
                                                                    Note
                                                                </span>
                                                                <span>
                                                                    النتـــيــجـة
                                                                </span>
                                                            </div>
                                                        </th>
                                                        <th className='bg-gray-200 border border-black'>
                                                            <div className="flex justify-between w-full">
                                                                <span>
                                                                    Matières Arabe
                                                                </span>
                                                                <span>
                                                                    مواد العربية
                                                                </span>
                                                            </div>
                                                        </th>

                                                    </tr>
                                                </thead>
                                                {loading ? <tbody><tr className='content-center items-center'><td className='content-center items-center' colSpan="9"><Loading /></td></tr></tbody> :
                                                    (
                                                        <tbody className='border border-black'>

                                                            {bulletinFondamental.lignes && bulletinFondamental.lignes.map(o => (
                                                                <>
                                                                    <tr className='font-semibold text-right h-3' >
                                                                        <td className='border  w-1/5 border-black'>{o.note}/{o.noteMax}</td>
                                                                        <td className='border border-black' >{o.libelle}</td>
                                                                    </tr>
                                                                </>
                                                            ))
                                                            }
                                                            <tr className='font-semibold bg-blue-300 text-right h-3' >
                                                                <td className='border  w-1/5 border-black'>{bulletinFondamental.totalAr}/{bulletinFondamental.totalMaxAr}</td>
                                                                <td className='border border-black' >المجموع</td>
                                                            </tr>
                                                        </tbody>
                                                    )
                                                }
                                            </table>
                                        </div>
                                        <div className="flex flex-wrap gap-1 justify-between my-2">
                                            <BulletinElement left="Mention: " center={bulletinFondamental.mention} right="التقدير:" />
                                            <BulletinElement left="Moyenne Min: " center={bulletinFondamental.moyenneMin} right="المعدل الأدنى:" />
                                            <BulletinElement left="Moyenne Max: " center={bulletinFondamental.moyenneMax} right="المعدل الأعلى:" />
                                            <BulletinElement left="Moyenne générale: " center={bulletinFondamental.moyenne} right=":المعدل العام" />
                                            <BulletinElement left="Total: " center={bulletinFondamental.total} right=":المجموع" />
                                            
                                        </div>
                                        <div className="flex w-full my-2 gap-1 justify-start items-start ">
                                            <div className="flex-col ">
                                                <div className="flex font-bold  justify-center items-center">
                                                    <h5>ختم و توقيع المدير العام</h5>
                                                </div>
                                                <div className="flex font-bold  justify-center items-center">
                                                    <h5>Signature et Cachet du Directeur Général</h5>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="flex w-full font-bold  gap-1 justify-center items-center ">
                                            <h3><u>Année scolaire: {bulletinFondamental.scolaire} : السنـــة الدراسيـــة</u></h3>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        }
                    </div>
                </div>
            </div>
        </>
    )
}

export default ShowBulletinFondamental